export default __webpack_public_path__ + "static/PromiseListMobTwo-615b8cf1350bcc069d868783a826273c.webp";